<template>
    <div id="metodosPagoStripe">

        <div class="text-center mt-5 mb-5" v-if="!isLoaded">
            <b-spinner label="Loading..."></b-spinner>
        </div>

        <template v-else>

            <b-row align-h="between">

                <b-col cols="auto">
                    <b-pagination v-if="!bottomPaginator && paginatedMethods.length" 
                        v-model="currentPage"
                        :total-rows="totalRows" 
                        :per-page="perPage" 
                        aria-controls="metodosPagoStripe" />
                </b-col>

                <b-col cols="auto" v-if="!allowSelect">
                    <b-button block variant="primary" @click="openNewPaymentModal">
                        <i class="fa fa-plus"></i>
                    </b-button>
                </b-col>

            </b-row>
            
            <b-card v-for="method in paginatedMethods" :key="method.id" class="card-item-pm mb-3">

                <b-card-title class="mb-0 text-left">
                    <!-- <div class="pm-icon"> -->
                        <!-- <div> -->
                            <!-- <span v-if="method.card.brand == 'visa'" class="imoon-visa"></span> -->
                            <!-- <span v-else class="imoon-mastercard"></span> -->
                        <!-- </div> -->
                    <!-- </div> -->
                    **** **** **** {{ method.card.last4 }}
                    <b-badge size="sx" variant="primary">{{ method.card.brand }}</b-badge>
                </b-card-title>

                <b-card-text>
                    <div class="text-left">
                        Expiración: {{ method.card.exp_month }}/{{ method.card.exp_year }}
                    </div>
                </b-card-text>

                <template v-if="allowSelect" #footer>
                    <div class="text-right">
                        <b-button-group size="sm">
                            <b-button v-if="pmSelected == method.id" @click="pmSelected = method.id" variant="primary">
                                Seleccionado
                            </b-button>
                            <b-button v-else @click="pmSelected = method.id" variant="outline-primary">
                                Seleccionar
                            </b-button>
                        </b-button-group>
                    </div>
                </template>

                <template v-else #footer>
                    <div class="text-right">
                        <b-button-group size="sm">
                            <b-button v-if="method.id == defaulMethod" variant="secondary" disabled>
                                Principal
                            </b-button>
                            <template v-else>
                                <b-button @click="askAndDeleteMethod(method.id)" variant="danger">
                                    <i class="fa fa-fw fa-trash"></i>
                                </b-button>
                                <b-button @click="setDefaultMethod(method.id)">
                                    Establecer como principal
                                </b-button>
                            </template>
                        </b-button-group>
                    </div>
                </template>

            </b-card>

            <b-jumbotron v-if="paymentMethods.length === 0" class="mt-2 mb-2">
                <template #lead>
                    Actualmente no tienes ningún método de pago registrado
                </template>
                <p v-if="!allowSelect">
                    Para agregar un nuevo  método de pago haz click en el botón de <i class="fa fa-plus"></i>
                </p>
                <p v-else>
                    Para agregar un nuevo  método de pago cierra este diálogo y haz click en el botón de 
                    <i class="fa fa-plus"></i> del módulo de métodos de pago.
                </p>
            </b-jumbotron>

            <template v-if="bottomPaginator && paginatedMethods.length">
                <hr>
                <b-row align-h="end">
                    <b-col cols="auto"> 
                        <b-pagination v-model="currentPage" 
                            :total-rows="totalRows" 
                            :per-page="perPage"
                            aria-controls="metodosPagoStripe" /> 
                    </b-col>
                </b-row>
            </template>

        </template>

        <metodos-pago-nuevo ref="metodosPagoNuevo" @paymentAdded="loadUp" />

    </div>
</template>

<script>
import axios from 'axios'

import _ from 'lodash'

import metodosPagoNuevo from './metodosPagoNuevo';
import { confirmFirst, notify } from '@/utils';
import stripeObj from '@/stripe/stripeHandler'

export default {
    name: 'metodosPagoStripe',
    components: {
        metodosPagoNuevo
    },
    props: {
        bottomPaginator: {
            type: Boolean,
            default: false
        },
        value: {
            type: [String, Number]
        },
        allowSelect: {
            type: Boolean,
            default: false
        },
        perPage: {
            type: Number,
            default: 3
        }
    },
    data() {
        return {
            isLoaded: true,
            paymentMethods: [],
            defaulMethod: null,
            pmSelected: null,
            currentPage: 1
        };
    },
    computed: {
        totalRows() {
            return this.paymentMethods.length;
        },
        paginatedMethods() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.paymentMethods.slice(start, end);
        }
    },
    methods: {
        openNewPaymentModal(){
            try {
                this.$refs.metodosPagoNuevo.open()
            } catch(e){
                notify(e)
            }
        },
        async askAndDeleteMethod(pmID) {
            const confirmed = await confirmFirst('¿Desea eliminar este método de pago?');
            if (confirmed) {
                try {
                    const response = await axios.delete('index.php?r=claveverde/stripeutils/removestripepaymentmethod/' + pmID);
                    if (!_.isObjectLike(response))
                        throw 'Error en la respuesta el servidor';
                    if (response.status) {
                        this.loadUp()
                    } else throw response.msg
                } catch (e) {
                    console.error(e);
                    notify(e)
                }
            }
        },
        async setDefaultMethod(pmID) {
            try {
                const response = await axios.get('index.php?r=claveverde/stripeutils/makepmdefault/' + pmID);
                if (!_.isObjectLike(response))
                    throw 'Error en la respuesta el servidor';
                if (response.status) {
                    this.defaulMethod = pmID;
                }
                else throw response.msg
            } catch (e) {
                console.error(e);
                notify(e)
            }
        },
        async loadUp() {
            this.isLoaded = false;
            this.paymentMethods = [];
            this.defaulMethod = null;
            try {
                const response = await axios.get('index.php?r=claveverde/stripeutils/getpaymentmethods')
                if (!_.isObjectLike(response))
                    throw 'Error en la respuesta el servidor';

                if ('stripePublicKey' in response)
                    stripeObj.setStripePublicKey(response.stripePublicKey)

                if (response.status) {
                    this.paymentMethods = response.data;
                    this.defaulMethod = response.default;
                    this.$emit('initialized', true);
                } else throw response.msg
            } catch (e) {
                console.error(e)
                notify(e)
            }
            this.isLoaded = true;
        }
    },
    beforeMount() {
        this.pmSelected = _.clone(this.value)
    },
    mounted() {
        this.loadUp()
    },
    watch: {
        pmSelected() {
            this.$emit('input', this.pmSelected)
        }
    }
};
</script>

<style lang="scss">
@import '@/scss/app.scss';

#metodosPagoStripe {

    .pm-icon {
        display: inline-flex;
        flex-flow: column;
        align-content: center;
        justify-items: center;
        border-radius: 3px;
        padding: 0 5px;

        div {
            // top: 3px;
            // right: 1px;
            // transform: scale(2);
        }
    }

}
</style>